import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";

import security from "../../services/security.js";
import auth from "../../services/auth.js";
import events from "../../services/events.js";
import companies from "../../services/companies.js";

class InboxController {
  constructor(
    $http,
    $localStorage,
    $state,
    $stateParams,
    AuthService,
    EventsService,
    CompaniesService,
    SecurityService,
    $rootScope,
    CommonService,
    EnvService,
    $timeout,
    $location,
    $scope,
    Messagingv2Service
  ) {
    this.name = "inbox";
    $localStorage.activeStateName = "inbox";

    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$scope = $scope;
    this.$auth = AuthService;
    this.$companies = CompaniesService;
    this.$events = EventsService;
    this.$stateParams = $stateParams;
    this.$location = $location;
    this.$security = SecurityService;
    this.$rootScope = $rootScope;
    this.query = "";
    this.$messagingv2 = Messagingv2Service;
    this.$common = CommonService;
    this.$env = EnvService;
    this.$timeout = $timeout;
    this.isPrivate = false;
    this.isPreferred = false;
    this.remain_loading_count = 1;
    this.event = {};
    this.teamsPostedTo = [];
    this.acceptedApplicants = [];
    this.currentUser = this.$auth.getUserData();
    this.events = [];
    this.arrayOfChannelsToDelete = [];
    this.collection_of_channel_ids = [];
    this.collection_of_channels = [];
    this.collection_of_eles = [];
    this.deletion_payload = {channels: [], events: []};
    this.$rootScope.messagesOffsetparam = 0;
    this.incrementChannelsSize = 20;
    this.busy = false;

    var _this = this;
  }
}

InboxController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "$stateParams",
  "auth",
  "events",
  "companies",
  "security",
  "$rootScope",
  "common",
  "env",
  "$timeout",
  "$location",
  "$scope",
  "messagingv2",
];

export default InboxController;



// WEBPACK FOOTER //
// ./client/app/components/inbox/inbox.controller.js